'use client';

import { createContext, useContext } from 'react';
import { FULL_SLOT, type ImageSlot } from './imageSlot';

/** See imageSlot.ts — the content-width share of the block tree below a row column. */
export const ImageSlotContext = createContext<ImageSlot>(FULL_SLOT);

export function useImageSlot(): ImageSlot {
  return useContext(ImageSlotContext);
}
